import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dish-list" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "search-input-wrapper" }
const _hoisted_4 = { class: "loader" }
const _hoisted_5 = {
  key: 1,
  class: "empty_list_message"
}
const _hoisted_6 = {
  key: 2,
  class: "error-message"
}

import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useModal } from 'vue-final-modal';

// Components
import AddDishForm from '@/components/AddDishForm.vue';
import DishListItem from '@/components/DishListItem.vue';
import DishListSelector from './DishListSelector.vue';

// Utils & Types
import { fetchWithAuth } from '@/utils/api';
import { type Dish } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'DishList',
  setup(__props) {

// Vue core
const store = useStore();
const apiUrl = store.getters.getApiUrl;

const show = ref(false);
const foodList = ref<Dish[] | null>(null);
const expandedItemIndex = ref<number | null>(null);
const searchQuery = ref('');
const list = ref<string>('current');
const fetchError = ref<string | null>(null);
const loading = ref(false);

function handleListChange(list: string) {
  foodList.value = null; // Reset food list when changing the list
  fetchDishItems(list);
}

const toggleAddDishForm = () => {
  show.value = true;
};

const hideForm = () => {
  show.value = false;
};

const dishAdded = (new_dish: Dish) => {
  foodList.value?.push({
    ...new_dish,
    logs: new_dish.logs ?? [],
  });
  show.value = false;
};

const toggleExpand = (index: number) => {
  expandedItemIndex.value = expandedItemIndex.value === index ? null : index;
};

const handleLogDeleted = (foodId: number, deletedLogId: number) => {
  foodList.value = foodList.value?.map((food) =>
    food.id === foodId
      ? { ...food, logs: food.logs?.filter((log) => log.id !== deletedLogId) ?? [] }
      : food
  ) || [];
};

const handleFoodDeleted = (deletedFoodId: number) => {
  foodList.value = foodList.value?.filter((food) => food.id !== deletedFoodId) || [];
};

const fetchDishItems = async (list: string) => {
  try {

    // Reset error state
    fetchError.value = null;
    loading.value = true;

    const response = await fetchWithAuth(`${apiUrl}/api/dishes/list/${encodeURIComponent(list)}`, { method: 'GET' }, store);
    if (response.ok) {
      const data = await response.json();
      foodList.value = data.map((item: Dish) => ({
        ...item,
        logs: item.logs ?? [],
      }));
    } else {
      const errorText = await response.text();
      fetchError.value = `Oh no! Something went wrong while loading dishes. Please try again later.`;
    }
    loading.value = false;
  } catch (error) {
    fetchError.value = 'Network error while loading dishes.';
    loading.value = false;
    console.error('Error fetching food items:', error);
  }
};

onMounted(() => fetchDishItems(list.value));

const filteredFoodList = computed(() =>
  foodList.value?.filter(food =>
    food.title.toLowerCase().includes(searchQuery.value.toLowerCase())
  ) ?? []
);


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DishListSelector, { onListChange: handleListChange }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Search dishes...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          class: "search-input",
          maxlength: "50"
        }, null, 512), [
          [_vModelText, searchQuery.value]
        ]),
        _createElementVNode("button", {
          class: "button primary add_dish_button",
          onClick: toggleAddDishForm
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] })
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, loading.value]
    ]),
    (filteredFoodList.value.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filteredFoodList.value, (food, index) => {
          return (_openBlock(), _createBlock(DishListItem, {
            key: food.id,
            id: food.id,
            title: food.title,
            progress: food.logs?.length || 0,
            goal: food.goal,
            foodId: food.id,
            logs: food.logs || [],
            expanded: expandedItemIndex.value === index,
            onToggle: ($event: any) => (toggleExpand(index)),
            onDeleted: handleFoodDeleted,
            onLogDeleted: handleLogDeleted
          }, null, 8, ["id", "title", "progress", "goal", "foodId", "logs", "expanded", "onToggle"]))
        }), 128))
      : (foodList.value && filteredFoodList.value.length === 0)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "No dishes found"))
        : _createCommentVNode("", true),
    (!foodList.value && fetchError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(fetchError.value), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchDishItems(list.value)))
          }, "Retry")
        ]))
      : _createCommentVNode("", true),
    _createVNode(AddDishForm, {
      onDishAdded: dishAdded,
      onHideForm: hideForm,
      show: show.value
    }, null, 8, ["show"])
  ]))
}
}

})